import servicesService from '@/modules/services/service/servicesService';

const PAGE_SIZE = 25;
const ALL_SERVICES_PAGE_SIZE = 100;
// Guards against infinite loops since services per business are unlimited.
// At ALL_SERVICES_PAGE_SIZE per page this covers 1000 services, well above current real-world usage.
const MAX_LOAD_ALL_ITERATIONS = 10;

const state = {
  services: [],
  loading: false,
  currentPageIndex: 0,
  completed: false,
};

const mutations = {
  addServices(state, services) {
    state.services = state.services.concat(services);
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
  setCompleted(state, completed) {
    state.completed = completed;
  },
  increaseCurrentPageIndex(state) {
    state.currentPageIndex += 1;
  },
  resetServices(state) {
    state.services = [];
    state.currentPageIndex = 0;
    state.completed = false;
  },
};

const actions = {
  async loadServices({ state, dispatch }) {
    if (state.services.length) return;
    await dispatch('loadMoreServices');
  },
  async loadAllServices({ state, commit, rootGetters }) {
    if (state.completed) return;
    if (state.services.length > 0) {
      commit('resetServices');
    }
    commit('setLoading', true);

    const businessId = rootGetters['AuthStore/businessUid'];
    let iterations = 0;
    while (!state.completed && iterations < MAX_LOAD_ALL_ITERATIONS) {
      try {
        // eslint-disable-next-line no-await-in-loop
        const services = await servicesService.fetchServices(businessId, state.currentPageIndex, ALL_SERVICES_PAGE_SIZE);
        commit('addServices', services);
        commit('increaseCurrentPageIndex');
        iterations += 1;
        if (services.length < ALL_SERVICES_PAGE_SIZE) {
          commit('setCompleted', true);
        }
      } catch (e) {
        console.log('Error loading all services', e); // eslint-disable-line no-console
        break;
      }
    }

    if (iterations >= MAX_LOAD_ALL_ITERATIONS) {
      console.log(`loadAllServices: reached maximum of ${MAX_LOAD_ALL_ITERATIONS} iterations (${MAX_LOAD_ALL_ITERATIONS * ALL_SERVICES_PAGE_SIZE}+ services)`); // eslint-disable-line no-console
    }

    commit('setLoading', false);
  },
  async loadMoreServices({ commit, state, rootGetters }) {
    if (state.completed || state.loading) return;
    commit('setLoading', true);

    try {
      const businessId = rootGetters['AuthStore/businessUid'];
      const services = await servicesService.fetchServices(businessId, state.currentPageIndex, PAGE_SIZE);
      commit('addServices', services);
      commit('increaseCurrentPageIndex');
      if (services.length < PAGE_SIZE) {
        commit('setCompleted', true);
      }
    } catch (e) {
      console.log('Error loading services', e); // eslint-disable-line no-console
    }

    commit('setLoading', false);
  },
};

const getters = {
  services: (state) => state.services,
  getServiceByUid: (state) => (uid) => state.services.find((service) => service.id === uid),
  loading: (state) => state.loading,
  completed: (state) => state.completed,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
